// src/pagos.js
// Lógica común de pagos: total, pagado, saldo y estado.
//
// Cada reserva/registro puede tener:
//   total        → monto a cobrar (si falta en reservas viejas de casas, se calcula aparte)
//   precioTipo   → "normal" | "acordado" | "sinCosto"  (lo define el admin)
//   pagos        → [{ id, monto, metodo, nota, por, fecha, anulado?, anuladoPor?, anuladoFecha? }]
//   montoPagado  → suma de los pagos no anulados (se guarda para el Worker de recordatorios)
//   paymentStatus→ "pendiente" | "parcial" | "confirmado" | "sinCosto" (se calcula solo)

export const ETIQUETAS_ESTADO = {
  pendiente: "Pago pendiente",
  parcial: "Pago parcial",
  confirmado: "Pago confirmado",
  sinCosto: "Sin costo",
};

export const etiquetaEstado = (estado) => ETIQUETAS_ESTADO[estado] || ETIQUETAS_ESTADO.pendiente;

const listaPagos = (item) => (Array.isArray(item?.pagos) ? item.pagos : []);

// Suma de los pagos que no fueron anulados
export const sumaPagos = (item) =>
  listaPagos(item)
    .filter((p) => !p.anulado)
    .reduce((acc, p) => acc + (Number(p.monto) || 0), 0);

// Estado según total y pagado
export const estadoPorMontos = (total, pagado) => {
  if (pagado <= 0) return "pendiente";
  return total - pagado <= 0 ? "confirmado" : "parcial";
};

// Resumen para mostrar: { total, pagado, saldo, estado }
// "total" es el monto a cobrar ya calculado (en casas viejas, recalculado por temporada).
export function resumenPago(item, total) {
  const t = Math.max(0, Number(total) || 0);

  if (item?.precioTipo === "sinCosto") {
    return { total: 0, pagado: 0, saldo: 0, estado: "sinCosto" };
  }

  // Reservas anteriores a este sistema: confirmadas a mano, sin pagos cargados → pagas
  if (listaPagos(item).length === 0 && item?.paymentStatus === "confirmado") {
    return { total: t, pagado: t, saldo: 0, estado: "confirmado" };
  }

  const pagado = sumaPagos(item);
  return {
    total: t,
    pagado,
    saldo: Math.max(0, t - pagado),
    estado: estadoPorMontos(t, pagado),
  };
}
